import {
  CELL_MARKS,
  type CellMark,
} from "@shared-core/domain/cost-matrix-cells";

const MARK_CLASSES: Record<CellMark, string> = {
  green: "text-[color:var(--color-success)]",
  amber: "text-amber-500",
  red: "text-destructive",
  grey: "text-muted-foreground",
};

/** One of the four marks — ● green, ● amber, ● red, ○ grey — meaning the
 *  same on every row of the cost matrix and on the cost-pair page. */
export function Mark({ mark }: { mark: CellMark }) {
  return (
    <span aria-hidden className={MARK_CLASSES[mark]}>
      {CELL_MARKS[mark].symbol}
    </span>
  );
}

/** "● Matches" — a mark and its message, as a matrix cell's line 2 and the
 *  cost-pair page's header both show it. */
export function MarkMessage({
  mark,
  message,
  className = "",
}: {
  mark: CellMark;
  message: string;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <Mark mark={mark} />
      <span>{message}</span>
    </span>
  );
}
